/**
 * 香港配置入口
 */
import { requireFiles } from 'common/utils'

export default requireFiles(require.context('./', true, /\.js$/))
